var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`c-button c-button-${_vm.type} ${_vm.styles} fb-center-center`,style:(_vm.computedSizeStyle),on:{"click":_vm.handlerClick}},[_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }